module.exports = __webpack_public_path__ + "image/contact-tel.png";